import Grid from '@mui/material/Grid';

import useGlobalState from 'actions';
import { CircularProgress } from '@julo-ui/progress';

const LoadingOverlay = () => {
  const [state] = useGlobalState();

  return state.isLoadingOverlayShown ? (
    <Grid
      container
      spacing={0}
      alignItems='center'
      justifyContent='center'
      position='fixed'
      top={0}
      right={0}
      width='100%'
      height='100%'
      zIndex={9999}
      style={{
        background: 'rgba(0,0,0,0.5)',
      }}
    >
      <CircularProgress isIndeterminate />
    </Grid>
  ) : null;
};

export default LoadingOverlay;
